module.exports = __webpack_public_path__ + "img/sign-65.012dafc9.jpg";